import { string } from 'zod'
import { ERRORS } from '~/shared/const'
import { PROJECT_NAME_MAX_LENGTH } from './const'

export function getProjectNameMaxLengthMessage() {
  return `Максимум ${PROJECT_NAME_MAX_LENGTH} символов`
}

export const projectNameSchema = string()
  .min(1, ERRORS.REQUIRED)
  .max(PROJECT_NAME_MAX_LENGTH, getProjectNameMaxLengthMessage())
